import { MapStepTable } from "./types";
import { responsiveZoomLevels } from "./responsiveZoom";
import { MOBILE_WIDTH } from "./config";

export function getSteps(ww: number): MapStepTable {
  const isMobile = ww <= MOBILE_WIDTH;

  const duration = 1500;

  const center: [number, number] = [-84.694, 40.3];
  const adjustedCenter: [number, number] = [-84.694, 40.35];

  return {
    0: {
      center,
      duration,
      zoom: responsiveZoomLevels.step0(),
      pitch: 0
    },
    1: {
      center,
      duration,
      zoom: responsiveZoomLevels.step1(),
      pitch: isMobile ? 0 : 45
    },
    2: {
      center,
      duration,
      zoom: responsiveZoomLevels.step2(),
      pitch: isMobile ? 0 : 45
    },
    3: {
      center,
      duration,
      zoom: responsiveZoomLevels.step3(),

      pitch: isMobile ? 0 : 45
    },
    4: {
      center: adjustedCenter,
      duration,
      zoom: responsiveZoomLevels.step4(),
      pitch: isMobile ? 0 : 45
    }
  };
}
